import { Spinner } from "@/components/atoms/Spinner";
import { createPortal } from "react-dom";

export const CalendarLoadingOverlay = () => {
  const calendarBodyRefs = document.getElementsByClassName("calendar-body");

  return Array.from(calendarBodyRefs || []).map((calendarBodyRef) =>
    createPortal(
      <tr className="tw-bg-base-white tw-flex tw-items-center tw-justify-center tw-inset-0 tw-absolute tw-bg-opacity-90 tw-z-50">
        <td>
          <Spinner appearance="black" size="large" />
        </td>
      </tr>,
      calendarBodyRef,
    ),
  );
};
